<template>
  <div class="right-panel">
    <!-- 搜索表单 -->
    <div class="display">
      <CustomSelect
        v-model="platForm.currencyCode"
        :options="currencyOptions"
        placeholder="Please select"
        label="Currency"
      />
      <CustomSelect
        v-model="platForm.providerId"
        :options="gameProviderOptions"
        placeholder="Please select"
        label="Provider"
        labelKey="providerName"
        valueKey="id"
      />
      <CustomRangePicker v-model="dateRange" @close="onClose" />
      <img class="imgRefrsh" :src="imgRefrsh" alt="imgRefrsh" @click="reFrsh" />
      <button class="export_button" @click="exportData">
        <img class="imgExport" :src="imgExport" alt="imgExport" />
        Export current list
      </button>
    </div>
    <span class="data_ago">Data from 24 hours ago</span>
    <!-- 表格区域 -->
    <el-table :data="originalData" stripe class="data-table">
      <el-table-column
        prop="providerName"
        label="Game provider"
      ></el-table-column>
      <el-table-column prop="num" label="Num"></el-table-column>
      <el-table-column prop="bet" label="BET"></el-table-column>
      <el-table-column prop="win" label="WIN"></el-table-column>
      <el-table-column prop="ggr" label="GGR"></el-table-column>
      <el-table-column prop="rtp" label="RTP"></el-table-column>
      <el-table-column prop="currencyCode" label="Currency"></el-table-column>
      <el-table-column prop="dateTime" label="Time"></el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalItems"
      :page-size="pageSize"
      style="--el-color-primary: #8e67ea"
      @current-change="handlePageChange"
    ></el-pagination>
  </div>
</template>

<script setup>
import "@/styles/tablePageStyle.css";
import { ref, onMounted, watch } from "vue";
import { useCommonStore } from "@/stores/packageStore";
import CustomSelect from "@/utils/CustomSelect.vue";
import { getCurrencyCode } from "@/stores/auth";
import CustomRangePicker from "@/utils/CustomRangePicker.vue";
import imgRefrsh from "@/assets/img_refrsh.svg";
import { ElMessage } from "element-plus";
import imgExport from "@/assets/img_export.svg";
import {
  getOriginalCurrencyList,
  originalCurrencyListExport,
} from "@/api/orderInformation";

const dateRange = ref({ start: null, end: null });
const originalData = ref([]);
const totalItems = ref(0);
const pageSize = ref(20);

const currencyOptions = getCurrencyCode().map((item) => ({
  label: item,
  value: item,
}));

const platForm = ref({
  providerId: "",
  currencyCode: "",
  startTime: "",
  endTime: "",
  page: 1,
  limit: pageSize.value,
});
const gameProviderOptions = ref([]);

const loadPackages = async () => {
  const commonStore = useCommonStore();
  await commonStore.fetchGameProvider();
  gameProviderOptions.value = commonStore.gameProvider;
};
const onClose = () => {
  console.log("弹窗关闭");
};
const reFrsh = () => {
  platForm.value.providerId = "";
  platForm.value.currencyCode = "";
  platForm.value.startTime = "";
  platForm.value.endTime = "";
  platForm.value.page = 1;
  platForm.value.limit = pageSize.value;

  dateRange.value = { start: null, end: null };
};

// 分页变化处理
const handlePageChange = (page) => {
  platForm.value.page = page; // 更新 platForm.page
  platForm.value.limit = pageSize.value; // 保持 limit
};
const fetchData = async () => {
  try {
    const response = await getOriginalCurrencyList(platForm.value);
    if (response.code === 200) {
      originalData.value = response.rows || [];
      totalItems.value = response.total;
    } else {
      ElMessage.error(response.msg);
    }
  } catch (error) {
    console.error("失败:", error);
  }
};
const fetchExportData = async () => {
  try {
    const response = await originalCurrencyListExport(platForm.value);
    if (response.code === 200) {
      const filePath = response.data.filePath;
      if (filePath) {
        // 创建 a 标签下载
        const link = document.createElement("a");
        link.href = filePath;
        link.download = filePath.split("/").pop(); // 设置下载文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        console.error("未返回文件路径");
      }
    } else {
      ElMessage.error(response.msg);
    }
  } catch (error) {
    console.error("失败:", error);
  }
};
const exportData = () => {
  fetchExportData();
};
onMounted(() => {
  fetchData();
  loadPackages();
});
watch(
  dateRange,
  (newVal) => {
    console.log("dateRange changed:", newVal);

    if (newVal.start && newVal.end) {
      platForm.value.startTime = newVal.start;
      platForm.value.endTime = newVal.end;
      console.log("platForm updated:", platForm.value);
    }
  },
  { deep: true }
);
watch(
  [platForm], // 监听这两个 ref
  () => {
    fetchData(); // 值变化时触发请求
  },
  { deep: true } // 对对象内部属性也生效
);
</script>

<style scoped>
.right-panel {
  flex: 38;
  padding: 24px;
  background: #ffffff;
  border-radius: 16px;
}
.label {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #333333;
}
/* 外层按钮样式 */
.date-display {
  display: flex;
  align-items: center;
  box-shadow: 0 0 0 1px #8e67ea inset; /* 内描边 */
  border-radius: 8px;
  cursor: pointer;
  background: #fff;
  height: 33px;
  width: 240px;
}
.date-display-normal {
  display: flex;
  align-items: center;
  box-shadow: 0 0 0 1px #dce3ea inset; /* 内描边 */
  border-radius: 8px;
  cursor: pointer;
  background: #fff;
  height: 33px;
  width: 240px;
}
.display {
  display: flex;
  align-items: center;
  gap: 24px;
}
.imgRefrsh {
  margin-left: 0;
}
.export_button {
  border: none;
  background: none;
  border-radius: 8px;
  color: #ffffff;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  background-color: #8e67ea;
  line-height: 12px;
  letter-spacing: 0%;
  padding: 10px 16px;
  cursor: pointer;
  display: flex;
  gap: 6px;
  align-items: center;
  margin-left: auto;
}
.data_ago {
  display: block; /* 或 inline-block */
  margin-top: 23px;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #9fa1a8;
}
</style>
